import { cn } from "../../lib/utils.ts";
import type { DocumentStatus, AlertLevel } from "../../types/fleet.ts";

interface StatusBadgeProps {
  status: DocumentStatus | AlertLevel;
  size?: "sm" | "md" | "lg";
  className?: string;
}

const statusConfig: Record<
  DocumentStatus | AlertLevel,
  { label: string; className: string }
> = {
  active: {
    label: "Vigente",
    className: "bg-status-active/15 text-status-active border-status-active/30",
  },
  warning: {
    label: "Por vencer",
    className:
      "bg-status-warning/15 text-status-warning border-status-warning/30",
  },
  urgent: {
    label: "Urgente",
    className: "bg-status-urgent/15 text-status-urgent border-status-urgent/30",
  },
  expired: {
    label: "Vencido",
    className:
      "bg-status-expired/15 text-status-expired border-status-expired/30",
  },
  renewed: {
    label: "Renovado",
    className:
      "bg-status-maintenance/15 text-status-maintenance border-status-maintenance/30",
  },
  info: {
    label: "Info",
    className:
      "bg-status-maintenance/15 text-status-maintenance border-status-maintenance/30",
  },
  critical: {
    label: "Crítico",
    className:
      "bg-status-expired/15 text-status-expired border-status-expired/30",
  },
};

const sizeClasses = {
  sm: "text-xs px-2 py-0.5",
  md: "text-sm px-2.5 py-1",
  lg: "text-base px-3 py-1.5",
};

export function StatusBadge({
  status,
  size = "md",
  className,
}: StatusBadgeProps) {
  const config = statusConfig[status];

  return (
    <span
      className={cn(
        "inline-flex items-center font-medium rounded-full border",
        config.className,
        sizeClasses[size],
        className
      )}
    >
      {config.label}
    </span>
  );
}
